import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {fetchTrainingItems as apiFetchTrainingItems, TrainingItem} from "../../actions/api";
import _ from "lodash";
import {RootState} from "../../configureStore";

interface TrainingState {
    trainingItems: TrainingItem[] | undefined
}

const initialState: TrainingState = {
    trainingItems: undefined
}

export const fetchTrainingItems = createAsyncThunk(
    'training/fetchTrainingItems',
    async () => {
        return apiFetchTrainingItems()
    }
)

export const trainingSlice = createSlice({
    name: 'training',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchTrainingItems.pending, (state) => {
            if (!_.isNil(state.trainingItems)) {
                state.trainingItems = undefined
            }
        })
        builder.addCase(fetchTrainingItems.fulfilled, (state, action) => {
            state.trainingItems = action.payload
        })
    },
})

export const selectTrainingItems = (state: RootState) => state.training.trainingItems;

export default trainingSlice.reducer


